import { render, staticRenderFns } from "./DefinirFoto.vue?vue&type=template&id=67b60b9a&scoped=true"
import script from "./DefinirFoto.vue?vue&type=script&lang=ts"
export * from "./DefinirFoto.vue?vue&type=script&lang=ts"
import style0 from "./DefinirFoto.vue?vue&type=style&index=0&id=67b60b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b60b9a",
  null
  
)

export default component.exports